import React from "react";
import { DistanceUnitsDropdown } from "./DistanceUnitsDropdown";

interface DistanceProps {
  distance: number;
  selectedDistanceUnits: string;
  setSelectedDistanceUnits: (units: string) => void;
}

export const Distance = (props: DistanceProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <span className="mr-1">Distance:</span>
        <span>
          {props.distance &&
            parseFloat(props.distance.toFixed(2)).toLocaleString()}
        </span>
      </div>
      <DistanceUnitsDropdown
        selectedDistanceUnits={props.selectedDistanceUnits}
        setSelectedDistanceUnits={props.setSelectedDistanceUnits}
      />
    </div>
  );
};
